<template>
    <div class="content-area">
        <div class="content-caption dashed">
            <span>收款详情</span>
        </div>
        <div class="form-single">
            <div class="title">收款单据号</div>
            <div class="content">
                <span>{{rcvVoucher.no}}</span>
                <el-tag class="ml10" type="danger" v-if="rcvVoucher.prePayFlag">预付</el-tag>
            </div>
        </div>
        <div class="form-single">
            <div class="title">来源类型</div>
            <div class="content">
                <span>{{ srcVoucherTypeMap[rcvVoucher.srcVoucherType] }}</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">来源单据号</div>
            <div class="content">
                <span>{{ rcvVoucher.srcVoucherInnerNo }}</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">收款主题</div>
            <div class="content">{{rcvVoucher.subject}}</div>
        </div>
        <div class="form-single">
            <div class="title">收款状态</div>
            <div class="content" v-if="rcvVoucher.rcvResult == 0">待收款</div>
            <div class="content" v-else>{{rcvResultMap[rcvVoucher.rcvResult]}}</div>
        </div>
        <hr/>
        <div class="form-single">
            <div class="title">付款方</div>
            <div class="content">{{rcvVoucher.payerRealComName}}</div>
        </div>
        <div class="form-single">
            <div class="title">付款方标识码</div>
            <div class="content">{{rcvVoucher.payerInnerNo}}</div>
        </div>
        <div class="form-single">
            <div class="title">付款银行</div>
            <div class="content">{{rcvVoucher.payBankName}}</div>
        </div>
        <div class="form-single">
            <div class="title">付款卡号</div>
            <div class="content">{{rcvVoucher.payCardNo || ''}}</div>
        </div>
        <div class="form-single">
            <div class="title">收款途径</div>
            <div class="content">{{rcvWayMap[rcvVoucher.rcvWay]}}</div>
        </div>
        <div class="form-single">
            <div class="title">收款方式</div>
            <div class="content"><span>{{ rcvMethodMap[rcvVoucher.rcvMethod] }}</span></div>
        </div>
        <div class="form-single">
            <div class="title">收款形式</div>
            <div class="content"><span>{{ rcvFormMap[rcvVoucher.rcvForm] }}</span></div>
        </div>
        <div class="form-single">
            <div class="title">收款银行</div>
            <div class="content">{{rcvVoucher.rcvBankName || ''}}</div>
        </div>
        <div class="form-single">
            <div class="title">收款卡号</div>
            <div class="content">{{rcvVoucher.rcvCardNo || ''}}</div>
        </div>
        <hr/>
        <div class="form-single" v-if="rcvVoucher.rcvPhaseId != -1">
            <div class="title">当前收款阶段</div>
            <div class="content">
                <span>{{rcvVoucher.rcvPhaseName || ''}} (付款比例{{(rcvVoucher.ratio || 0).toFixed(2)}}%)</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">本次需收金额</div>
            <div class="content">
                <span class="font-red font16" v-if="rcvVoucher.prePayFlag"><b>{{(parseFloat(rcvVoucher.amountPre || 0)).toFixed(2)}}</b> 元</span>
                <span class="font-red font16" v-else><b>{{(parseFloat(rcvVoucher.amount || 0)).toFixed(2)}}</b> 元</span>
            </div>
        </div>
        <el-table :data="payItems" border style="width: 100%" v-if="payItems != null && payItems.length > 0">
            <el-table-column align="left" prop="rcvPhaseName" label="阶段名称"></el-table-column>
            <el-table-column align="right" prop="amount" label="本次应收款金额(元)" width="200">
                <template slot-scope="scope">
                    <span>{{(scope.row.amount || 0).toFixed(2)}}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" prop="amount" label="本次实际收款金额(元)" width="200">
                <template slot-scope="scope">
                    <span>{{(scope.row.amount || 0).toFixed(2)}}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="form-single" v-if="!rcvVoucher.prePayFlag">
            <div class="title">本次实际收款金额</div>
            <div class="content">
                <span class="font-red font16" v-if="rcvVoucher.prePayFlag"><b>{{(parseFloat(rcvVoucher.amountPre || 0)).toFixed(2)}}</b> 元</span>
                <span class="font-red font16" v-else><b>{{(parseFloat(rcvVoucher.amountPost || 0)).toFixed(2)}}</b> 元</span>
            </div>
        </div>
        <div v-if="optionFlag == 'chaKan'">
            <div class="form-single">
                <div class="title">申请状态</div>
                <div class="content">
                    <span>{{applyStateMap[rcvVoucher.applyState]}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">申请描述</div>
                <div class="content">
                    <span>{{rcvVoucher.applyDesc}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">审核状态</div>
                <div class="content">
                    <span>{{auditStateMap[rcvVoucher.auditState]}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">审核描述</div>
                <div class="content">
                    <span>{{rcvVoucher.auditDesc}}</span>
                </div>
            </div>
        </div>
        <div class="form-single">
            <div class="title">留言</div>
            <div class="content" v-if="optionFlag == 'fuKuan'">
                <textarea v-model="rcvVoucher.memo" style="width: 320px;height: 90px"></textarea>
            </div>
            <div class="content" v-if="optionFlag != 'fuKuan'">
                <span>{{rcvVoucher.memo}}</span>
            </div>
        </div>
        <div v-if="optionFlag == 'shenHe'">
            <div class="form-single">
                <div class="title">审核结果</div>
                <div class="content">
                    <el-radio class="radio" v-for="auditStateInfo in auditStateList" v-model="rcvVoucher.auditState" :label="auditStateInfo.value">
                        <span>{{auditStateInfo.text}}</span>
                    </el-radio>
                </div>
            </div>
            <div class="form-single">
                <div class="title">审核描述</div>
                <div class="content">
                    <textarea v-model="rcvVoucher.auditDesc" style="width: 320px;height: 90px"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'

import finacApi from '../../api/finac'

export default{
    name: 'swb-rcv-voucher-info',
    desc: '收款详情',
    props: ['voucherId', 'optionFlag'],
    data: function () {
        return {
            rcvVoucher: {
                auditState: getEnumInfoWith('auditState', 'name', 'AuditPass').value
            },
            payItems: [], // 支付项
            auditStateList: [],
            srcVoucherTypeMap: getEnumMap("srcVoucherType", "value2text"),
            rcvResultMap: getEnumMap("resultState", "value2text"),
            rcvWayMap: getEnumMap("payWay", "value2text"),
            rcvFormMap: getEnumMap("payForm", "value2text"),
            rcvMethodMap: getEnumMap("payMethod", "value2text"),
            applyStateMap: getEnumMap("applyState", "value2text"),
            auditStateMap: getEnumMap("auditState", "value2text")
        }
    },
    created: function () {
        //
        this.getRcvVoucherInfo();
        this.getAuditState();
    },
    methods: {
        getAuditState: function () {
            this.auditStateList = getEnumInfoWith('auditState', 'name', ['AuditFail', 'AuditPass']);
        },
        getRcvVoucherInfo: function () {
            let self = this;
            let postData = {};
            postData.id = self.voucherId;
            //
            let msgBoxDlg = MsgBox.loading();
            //
            finacApi.getRcvVoucherCOById(postData, function (result) {
                msgBoxDlg.close();
                if (result.type == 'info') {
                    let rcvVoucher = result.data;
                    //
                    let payItems = [];
                    let payItem = {
                        rcvPhaseName: rcvVoucher.rcvPhaseName,
                        amount: rcvVoucher.amount
                    };
                    payItems.push(payItem);
                    //
                    self.payItems = Utils.merge([], payItems);
                    self.rcvVoucher = Utils.merge({}, rcvVoucher);
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        getDlgResult: function () {
            let self = this;
            let result = {};
            result.data = self.rcvVoucher;
            result.type = "info";
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/payment/RcvVoucherInfo.vue